import { getViewportTier } from "."

const SESSION_STORAGE_KEY = "rr_sid"

function getSessionToken() {
  if (window.RR_SESSION) return window.RR_SESSION

  try {
    return window.sessionStorage.getItem(SESSION_STORAGE_KEY) || ""
  } catch {
    return ""
  }
}

function isEmbedded() {
  try {
    return window.top !== window.self
  } catch {
    return true
  }
}

export function rrFetch(input, init = {}) {
  const options = { ...init }

  const headers = new Headers(init?.headers ? init.headers : {})

  if (isEmbedded()) {
    headers.set("X-RR-Embed", "1")
  }

  const token = getSessionToken()
  if (token) {
    headers.set("X-Session", token)
  }

  const tier = getViewportTier()
  headers.set("X-RR-Device", tier)

  options.headers = headers

  return fetch(input, options)
}
